// src/firebase.js
import { initializeApp } from 'firebase/app';
import { getAuth, GoogleAuthProvider, signInWithPopup } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';

const firebaseConfig = {
  apiKey: "AIzaSyBkmeuX1RVl2m3XH7_VyEtoyLIedgJAZRU",
  authDomain: "auth.iburtum.xyz",
  projectId: "brttree-87425",
  storageBucket: "brttree-87425.firebasestorage.app",
  messagingSenderId: "731038983038",
  appId: "1:731038983038:web:d5d173ae3da6dde22ec92f",
  measurementId: "G-Z0KS8D1N3Y"
};

const app = initializeApp(firebaseConfig);
const auth = getAuth(app);
const db = getFirestore(app);

const googleProvider = new GoogleAuthProvider();

export { auth, googleProvider, signInWithPopup, db };
